import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { MainRoutes } from '../../models/core/routes.models';

export const authGuard: CanActivateChildFn = () => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);

  if (AuthenticationService.User()) {
    return true;
  }

  const storedUser = authService.getLocalStorageUser();
  if (storedUser) {
    AuthenticationService.User.set(storedUser);
    return true;
  }

  void router.navigate([MainRoutes.LOGIN]);
  return false;
};
